import React from 'react';
import { Button, ButtonsGroup, Layout, Text } from '@netapp/bxp-design-system-react';
import { ConfigurationBaseCard, ConfigurationBaseFooter } from 'modules/console/configurations';
import PermissionComponent from 'modules/app/components/permission/PermissionComponent';
import styles from '../../style.module.scss';

const footerStyle = { justifyContent: 'flex-start', borderTop: '0px', alignItems: 'flex-end', marginTop: 'auto' };

const ConfigurationInfoCard = ({
    title,
    description,
    descriptionClassName,
    showStatus,
    iconRenderer,
    actionLabel,
    onAction,
    isActionDisabled = false,
    hasPermission = true,
    hasNoPermission = false,
    hasError = false,
    errorMessage,
}) => {
    return (
        <ConfigurationBaseCard
            title={title}
            iconRenderer={iconRenderer}
            hasNoPermission={hasNoPermission}
            hasError={hasError}
            errorMessage={errorMessage}
        >
            {description && (
                <Layout.Grid rowGap='lg'>
                    <Layout.GridItem lg={12}>
                        <Text className={descriptionClassName}>{description}</Text>
                    </Layout.GridItem>
                </Layout.Grid>
            )}
            {showStatus && (
                <div className={description ? styles.configurationCardStatusHidden : undefined}>
                    {showStatus}
                </div>
            )}
            <ConfigurationBaseFooter style={footerStyle}>
                <ButtonsGroup>
                    <PermissionComponent hasPermssion={hasPermission}>
                        <Button
                            color="secondary"
                            className={styles.width152}
                            disabled={isActionDisabled}
                            onClick={onAction}
                        >
                            {actionLabel}
                        </Button>
                    </PermissionComponent>
                </ButtonsGroup>
            </ConfigurationBaseFooter>
        </ConfigurationBaseCard>
    )
}

export default React.memo(ConfigurationInfoCard);
